/**
 * Shared date/time display format for the business_applications plugin:
 * DD/MM/YYYY, HH:mm:ss (24-hour), independent of the viewer's browser locale.
 *
 * `toLocaleString()` with no locale follows the browser, which is why en-US
 * browsers showed `9/14/2026, 8:57:44 AM`. The time zone is still the
 * viewer's local one.
 */
const DATE_TIME_FORMAT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
});

/** Formats an ISO timestamp; returns the input unchanged if it is not a date. */
export function formatDateTime(value: string | number | Date): string {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime())
    ? String(value)
    : DATE_TIME_FORMAT.format(date);
}
